import { Box } from "@chakra-ui/react"

import { PublicHeader } from "@/components/layout/PublicHeader"
import { PasswordResetForm } from "@/features/auth"
import useAuth from "@/hooks/useAuth"
import { createFileRoute, redirect } from "@tanstack/react-router"

function ForgotPasswordPage() {
  const { isAuthenticated } = useAuth()

  // Redirect to dashboard if already logged in
  if (isAuthenticated) {
    throw redirect({ to: "/" })
  }

  return (
    <Box minH="100vh">
      <PublicHeader hideAuthButtons />
      <PasswordResetForm onSuccess={(_email) => {}} />
    </Box>
  )
}

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
})
